import httpRequest, { getTraceId } from 'utils/httpRequest';
import queryString from 'utils/queryString';

import SETTINGS from '../settings';

const withApiHost = url =>
  queryString.addParams(`${SETTINGS.API_HOST}/${url}`, { client_id: SETTINGS.CLIENT_ID });

const withApiHeaders = headers => ({
  'Content-Type': 'application/json',
  'X-User-Agent': SETTINGS.USER_AGENT,
  'X-Trace-Id': getTraceId(),
  ...headers,
});

const withApiBody = body => ({
  client_id: SETTINGS.CLIENT_ID,
  ...body,
});

export const apiClientGetRequest = async (url, headers = {}, opts = {}) => {
  const response = await httpRequest(withApiHost(url), {
    method: 'GET',
    headers: withApiHeaders(headers),
    ...opts,
  });

  return response;
};

export const apiClientHeadRequest = async (url, headers = {}, opts = {}) => {
  const response = await httpRequest(withApiHost(url), {
    method: 'HEAD',
    headers: withApiHeaders(headers),
    ...opts,
  });

  return response;
};

export const apiClientPostRequest = async (url, body = {}, headers = {}, opts = {}) => {
  const response = await httpRequest(withApiHost(url), {
    method: 'POST',
    headers: withApiHeaders(headers),
    body: withApiBody(body),
    ...opts,
  });

  return response;
};

export const apiClientPutRequest = async (url, body = {}, headers = {}, opts = {}) => {
  const response = await httpRequest(withApiHost(url), {
    method: 'PUT',
    headers: withApiHeaders(headers),
    body: withApiBody(body),
    ...opts,
  });

  return response;
};

export const apiClientDeleteRequest = async (url, headers = {}, body = {}, opts = {}) => {
  const response = await httpRequest(withApiHost(url), {
    method: 'DELETE',
    headers: withApiHeaders(headers),
    body: withApiBody(body),
    ...opts,
  });

  return response;
};
